import {FormControl, ValidationErrors} from '@angular/forms';

export default function (control: FormControl): ValidationErrors | null {
  const value = control.value;
  if (value !== 1 && value !== 2) return {required: true};
  return null;
}
